
import { Vue, Component, Ref, Model, Watch } from 'vue-property-decorator';
import VehicleModule from '@/components/carModule/VehicleModule.vue';

@Component({
  components: {
    VehicleModule,
  },
})
export default class NameField extends Vue {
  name = 'NameField';
  val = '';

  @Ref()
  vehicleModule!: VehicleModule;

  init() {
    this.vehicleModule.init();
  }


  updateName(name: any) {
    this.val = `${name.brand}/${name.series}/${name.model_name}`;
  }


  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = `${this.value}`;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
